export default __webpack_public_path__ + "static/media/avatar_grumpy_cat5.bceba30c.mp3";